import { render, staticRenderFns } from "./Locataire.vue?vue&type=template&id=09207444&scoped=true&"
import script from "./Locataire.vue?vue&type=script&lang=js&"
export * from "./Locataire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09207444",
  null
  
)

export default component.exports